/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardText,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  ThemeWrapper,
  FormGroup,
  Form,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";

import { ThemeContext, themes } from "contexts/ThemeContext";
import { backgroundColors } from "contexts/BackgroundColorContext";
import { connect } from "react-redux";

function Settings(props) {
  // const [profilePic, setProfilePic] = React.useState(props.imgURL);
  // const [firstName, setFirstName] = React.useState("First");
  // const [lastName, setLastName] = React.useState("Last");
  // const [tagline, setTagline] = React.useState("Tagline");
  // const [description, setDescription] = React.useState("About me");
  // const [username, setUsername] = React.useState("Username");
  // const [city, setCity] = React.useState("City");
  // const [country, setCountry] = React.useState("Country");
  // const [zip, setZip] = React.useState(0);
  // const [email, setEmail] = React.useState("email@example.com");
  // const [curNotif, setCurNotif] = React.useState("Email for important updates");
  // const [option1, setOption1] = React.useState("Email for all updates");
  // const [option2, setOption2] = React.useState("Never email me");
  const [isDarkMode, setDarkMode] = React.useState(false);

  function switchTheme(changeTheme, theme, tf) {
    changeTheme(theme);
    localStorage.setItem("darkmode", tf);
    switchLocalStorage();
  }
  function switchLocalStorage() {
    if (localStorage.getItem("darkmode") == "f") {
      setDarkMode(false);
    } else {
      setDarkMode(true);
    }
  }
  useEffect(() => {
    switchLocalStorage();
  });
  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card className="card-tasks" style={{ height: "100%" }}>
              <CardHeader>
                <h2 className="title" style={{marginBottom: 0}}>Settings</h2>
              </CardHeader>
              <CardBody>
                  <label>
                    <h3 style={{ marginBottom: 5}}>Theme
                    </h3>
                  </label>
                  <Form>
                    {isDarkMode ? (
                      <Col className="pr-md-1" md="6" style={{marginLeft: 10}}>
                        <ThemeContext.Consumer>
                          {({ changeTheme }) => (
                            <>
                              <div className="form-check-theme">
                                <Label className="form-check-label">
                                  <Input
                                    type="radio"
                                    style={{cursor: 'pointer'}}
                                    name="exampleRadios"
                                    id="exampleRadios1"
                                    value="option1"
                                    onClick={() =>
                                      switchTheme(
                                        changeTheme,
                                        themes.light,
                                        "f"
                                      )
                                    }
                                  />
                                  Light Mode
                                  <span className="form-check-sign"></span>
                                </Label>
                              </div>
                              <div className="form-check-theme">
                                <Label className="form-check-label">
                                  <Input
                                    type="radio"
                                    style={{cursor: 'pointer'}}
                                    name="exampleRadios"
                                    id="exampleRadios2"
                                    value="option2"
                                    defaultChecked
                                    onClick={() =>
                                      switchTheme(changeTheme, themes.dark, "t")
                                    }
                                  />
                                  Dark Mode
                                  <span className="form-check-sign"></span>
                                </Label>
                              </div>
                            </>
                          )}
                        </ThemeContext.Consumer>
                      </Col>
                    ) : (
                      <Col className="pr-md-1" md="6" style={{marginLeft: 10}}>
                        <ThemeContext.Consumer>
                          {({ changeTheme }) => (
                            <>
                              <div className="form-check-theme">
                                <Label className="form-check-label">
                                  <Input
                                    type="radio"
                                    style={{cursor: 'pointer'}}
                                    name="exampleRadios"
                                    id="exampleRadios1"
                                    value="option1"
                                    defaultChecked
                                    onClick={() =>
                                      switchTheme(
                                        changeTheme,
                                        themes.light,
                                        "f"
                                      )
                                    }
                                  />
                                  Light Mode
                                  <span className="form-check-sign"></span>
                                </Label>
                              </div>
                              <div className="form-check-theme">
                                <Label className="form-check-label">
                                  <Input
                                    type="radio"
                                    style={{cursor: 'pointer'}}
                                    name="exampleRadios"
                                    id="exampleRadios2"
                                    value="option2"
                                    onClick={() =>
                                      switchTheme(changeTheme, themes.dark, "t")
                                    }
                                  />
                                  Dark Mode
                                  <span className="form-check-sign"></span>
                                </Label>
                              </div>
                            </>
                          )}
                        </ThemeContext.Consumer>
                      </Col>
                    )}
                  </Form>
                {/*<Card>
                    <label><h4 style={{marginBottom: 0}}><b>Account Settings</b></h4></label>
                    <Form>
                    <Col className="pr-md-1" md="6">
                      <div className="form-check-privacy">
                            <Label className="form-check-label">
                                <Input type="radio" name="exampleRadios" id="exampleRadios1" value="option1" />
                                       Private Mode 
                                <span className="form-check-sign"></span>
                            </Label>
                        </div>
                        <div className="form-check-privacy">
                            <Label className="form-check-label">
                            <Input type="radio" name="exampleRadios" id="exampleRadios2" value="option2" defaultChecked/>
                                   Public Mode 
                            <span className="form-check-sign"></span>
                            </Label>
                        </div>
                    </Col>
                    
                </Form>
                </Card>
                <Card>
                <label><h4 style={{marginBottom: 0}}><b>Notifications</b></h4></label>
                <Form>
                <Col className="pr-md-1" md="6">
                        <div className="form-check-notif">
                            <Label className="form-check-label">
                                <Input type="radio" name="exampleRadios" id="exampleRadios1" value="option1" />
                                       Email for all updates
                                       
                                <span className="form-check-sign"></span>
                            </Label>
                        </div>
                        <div className="form-check-notif">
                            <Label className="form-check-label">
                            <Input type="radio" name="exampleRadios" id="exampleRadios2" value="option2" defaultChecked/>
                                   Email for important updates  
                            <span className="form-check-sign"></span>
                            </Label>
                        </div>
                        <div className="form-check-notif">
                            <Label className="form-check-label">
                            <Input type="radio" name="exampleRadios" id="exampleRadios3" value="option3"  />
                                   Never email me 
                            <span className="form-check-sign"></span>
                            </Label>
                        </div>
                  </Col>
                  </Form>
                  </Card>
                  <Button className="btn-fill" color="red" type="submit">
                    Upgrade to Pro
                  </Button>
                  <Button className="btn-fill" color="red" type="submit" style={{color: "red"}}>
                    Delete Account
                  </Button>*/}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  imgURL: state.imgURL,
});

export default connect(mapStateToProps)(Settings);
